import React, { useState } from "react";
import {
  Star,
  Edit2,
  Trash2,
  MessageSquare,
  Image as ImageIcon,
} from "lucide-react";

const Reviews = () => {
  const [activeTab, setActiveTab] = useState("published");

  const reviews = {
    published: [
      {
        id: 1,
        image:
          "https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcQUz4H8LeEVK9OIdEXIJc9npScg75NS2PCyRqHTpWHZitGDFPMLiStjl7o5Igh8SppdZk3xV_rA3Gr_JTHSFFzUnH9XiDe5qi-JJA1uxVVt2HTf0B8S93LNn6zNftc8GIaf40s__Ng&usqp=CAc",
        item: "Gold Necklace",
        description: "Elegant 18K gold necklace with intricate design",
        rating: 5,
        review:
          "Absolutely stunning piece! The craftsmanship is exceptional and it looks even better in person. The delivery was quick and the packaging was secure.",
        reviewDate: "2024-01-15",
        likes: 12,
        helpful: 8,
      },
      {
        id: 2,
        image:
          "https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcSCzQ3U-bfV6aJ9SqW7U_eCCz1ClpsejJUAEwC3HGJQG54TJY37rRZ9dcfnmX2YuD2jpFipq6aaixK1mWlvoO8wqe5Gmvb6sIPNwiW65SPpQiTGEr0-7MAm1s93OjBFNSZVPJ8-hIKB&usqp=CAc",
        item: "Silver Ring",
        description: "Beautiful silver ring with stone embellishment",
        rating: 4,
        review:
          "Beautiful ring, great quality. Slightly larger than expected but still looks fantastic.",
        reviewDate: "2024-01-10",
        likes: 5,
        helpful: 3,
      },
    ],
    pending: [
      {
        id: 3,
        image: "/api/placeholder/100/100",
        item: "Diamond Earrings",
        description: "Classic diamond studded earrings",
        purchaseDate: "2024-01-01",
        reviewDeadline: "2024-02-01",
      },
    ],
  };

  const StarRating = ({ rating }) => {
    return (
      <div className="flex items-center space-x-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            className={`w-4 h-4 ${
              star <= rating
                ? "text-yellow-400 fill-current"
                : "text-purple-200"
            }`}
          />
        ))}
      </div>
    );
  };

  const handleEditReview = (reviewId) => {
    console.log(`Editing review ${reviewId}`);
  };

  const handleDeleteReview = (reviewId) => {
    console.log(`Deleting review ${reviewId}`);
  };

  const handleWriteReview = (itemId) => {
    console.log(`Writing review for item ${itemId}`);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-2xl font-medium text-purple-900">My Reviews</h3>
        <div className="flex space-x-2">
          <button
            onClick={() => setActiveTab("published")}
            className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 transform hover:scale-105 ${
              activeTab === "published"
                ? "bg-purple-700 text-white shadow-md"
                : "text-purple-600 hover:bg-purple-50"
            }`}
          >
            Published ({reviews.published.length})
          </button>
          <button
            onClick={() => setActiveTab("pending")}
            className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 transform hover:scale-105 ${
              activeTab === "pending"
                ? "bg-purple-700 text-white shadow-md"
                : "text-purple-600 hover:bg-purple-50"
            }`}
          >
            Pending ({reviews.pending.length})
          </button>
        </div>
      </div>

      <div className="space-y-4">
        {activeTab === "published"
          ? reviews.published.map((review) => (
              <div
                key={review.id}
                className="bg-white border border-purple-200 rounded-lg p-6 hover:shadow-md transition-all duration-200"
              >
                <div className="flex space-x-6">
                  <img
                    src={review.image}
                    alt={review.item}
                    className="w-24 h-24 rounded-lg object-cover"
                  />
                  <div className="flex-grow space-y-4">
                    <div className="flex justify-between">
                      <div>
                        <h4 className="font-medium text-purple-900">
                          {review.item}
                        </h4>
                        <p className="text-sm text-purple-600">
                          {review.description}
                        </p>
                      </div>
                      <div className="flex space-x-2">
                        <button
                          onClick={() => handleEditReview(review.id)}
                          className="p-2 text-purple-600 hover:text-purple-900 transition-colors duration-200"
                        >
                          <Edit2 className="w-5 h-5" />
                        </button>
                        <button
                          onClick={() => handleDeleteReview(review.id)}
                          className="p-2 text-purple-600 hover:text-red-600 transition-colors duration-200"
                        >
                          <Trash2 className="w-5 h-5" />
                        </button>
                      </div>
                    </div>

                    <div className="flex items-center space-x-4">
                      <StarRating rating={review.rating} />
                      <span className="text-sm text-purple-500">
                        Posted on {review.reviewDate}
                      </span>
                    </div>

                    <p className="text-purple-700">{review.review}</p>

                    <div className="flex items-center space-x-6 text-sm">
                      <button className="flex items-center space-x-2 text-purple-600 hover:text-purple-900">
                        <MessageSquare className="w-4 h-4" />
                        <span>{review.helpful} people found this helpful</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          : reviews.pending.map((item) => (
              <div
                key={item.id}
                className="bg-white border border-purple-200 rounded-lg p-6 hover:shadow-md transition-all duration-200"
              >
                <div className="flex space-x-6">
                  <img
                    src={item.image}
                    alt={item.item}
                    className="w-24 h-24 rounded-lg object-cover"
                  />
                  <div className="flex-grow">
                    <div className="flex justify-between items-start">
                      <div className="space-y-1">
                        <h4 className="font-medium text-purple-900">
                          {item.item}
                        </h4>
                        <p className="text-sm text-purple-600">
                          {item.description}
                        </p>
                        <p className="text-sm text-purple-500">
                          Purchased on {item.purchaseDate}
                        </p>
                      </div>
                      <button
                        onClick={() => handleWriteReview(item.id)}
                        className="flex items-center space-x-2 px-4 py-2 bg-purple-700 text-white rounded-lg hover:bg-purple-600 transition-all duration-200 transform hover:scale-105 shadow-md"
                      >
                        <Edit2 className="w-4 h-4" />
                        <span>Write Review</span>
                      </button>
                    </div>
                    <div className="mt-4 p-4 bg-purple-50 rounded-lg border border-purple-200">
                      <p className="text-sm text-purple-800">
                        Review deadline: {item.reviewDeadline}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
      </div>

      {/* Decorative pattern overlay */}
      <div
        className="absolute inset-0 pointer-events-none opacity-30"
        style={{
          backgroundImage: `
               linear-gradient(to right, rgba(147, 51, 234, 0.05) 1px, transparent 1px),
               linear-gradient(to bottom, rgba(147, 51, 234, 0.05) 1px, transparent 1px)
             `,
          backgroundSize: "50px 50px",
        }}
      />
    </div>
  );
};

export default Reviews;
